import type { MeasurementsEvent, MeasurementsSnapshot, MeasurementsState } from './types.js';

// Pure reducer. No I/O. Returns same reference on no-op transitions so
// dispatch can short-circuit equality checks.
export function measurementsTransition(
  state: MeasurementsState,
  event: MeasurementsEvent,
): MeasurementsState {
  switch (event.type) {
    case 'TOGGLE_ACTIVE':
      return { ...state, active: !state.active };
    case 'EXIT':
      if (!state.active) return state;
      return { ...state, active: false };
    case 'ADD_POINT': {
      // Defensive: orchestrator early-returns when not active, but the
      // reducer also guards so the SM stays consistent under any caller.
      if (!state.active) return state;
      return {
        ...state,
        points: [...state.points, { id: event.id, world: event.world }],
      };
    }
    case 'REMOVE_LAST':
      if (state.points.length === 0) return state;
      return { ...state, points: state.points.slice(0, -1) };
    case 'RESET_ALL':
      if (state.points.length === 0) return state;
      return { ...state, points: [] };
    case 'SET_UNITS':
      if (state.units === event.units) return state;
      return { ...state, units: event.units };
  }
}

export function measurementsSnapshot(state: MeasurementsState): MeasurementsSnapshot {
  return {
    active: state.active,
    points: state.points,
    units: state.units,
    pointCount: state.points.length,
  };
}
